import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import DownSvg from './down.svg';
import UpSvg from './up.svg';
import './style.scss';

const DATA_VALUE = 'data-value';
const DATATYPE_OBJECT = 'object';
const CLICK_EVENT = 'click';

export function Dropdown(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelection] = useState(null);
  const [allOptions, setAllOptions] = useState([]);
  let wrapRef = useRef(null);

  function externalClickEventListener(event) {
    let node = wrapRef.current;
    if (node && node.contains(event.target) === false) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener(CLICK_EVENT, externalClickEventListener);
    return () => {
      document.removeEventListener(CLICK_EVENT, externalClickEventListener);
    };
  }, []);

  useEffect(() => {
    let toSetOptions = props.options.map((option) => {
      if (typeof option === DATATYPE_OBJECT) {
        return {...option};
      } else {
        return {value: option, label: option};
      }
    });
    setAllOptions(toSetOptions);
    if (props.value !== null || props.value !== undefined) {
      let option = toSetOptions.find((option) => option.value === props.value);
      setSelection(option ?? null);
    }
  }, [props.options, props.value]);

  function selectedOption() {
    if (selected === null) {
      return props.placeholder;
    } else {
      return selected.label;
    }
  }

  function getIcon() {
    if (isOpen) {
      return UpSvg;
    } else {
      return DownSvg;
    }
  }

  function openList() {
    if (props.disabled) {
      setIsOpen(false);
    } else {
      setIsOpen(!isOpen);
    }
  }

  function optionClick(event) {
    let value = parseInt(event.target.getAttribute(DATA_VALUE));
    let option = allOptions.find((option) => option.value === value);
    setSelection(option);
    setIsOpen(false);
    props.onChange(option);
  }

  function renderOptions() {
    return allOptions.map((option) => (
      <li
        key={option.value}
        className='option-item'
        data-value={option.value}
        onClick={optionClick}>
        <span style={{pointerEvents: "none"}}>{option.label}</span>
      </li>
    ));
  }

  function getHeaderClassName() {
    return `react-dropdown-header ${props.disabled ? 'disabled' : ''}`;
  }

  function getWrapperClassName() {
    return `react-dropdown ${props.className}`;
  }

  function renderOptionsList() {
    return (
      isOpen && <ul className='react-dropdown-options'>{renderOptions()}</ul>
    );
  }

  return (
    <div className={getWrapperClassName()} ref={wrapRef}>
      <div className={getHeaderClassName()} onClick={openList}>
        <span className='label'>{selectedOption()}</span>
        <img className='icon' src={getIcon()} alt='dropdown icon' />
      </div>
      {renderOptionsList()}
    </div>
  );
}

Dropdown.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Dropdown.defaultProps = {
  onChange: () => {},
  placeholder: 'Please select.',
  className: '',
};
